// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tour-modal{display:flex}.tour-modal img{width:505px;-o-object-fit:cover;object-fit:cover}.tour-modal__info{padding:32px;width:295px}.tour-modal__info--buttons{margin-top:30px}.tour-modal__info--buttons .cv-button{display:flex;flex-direction:column;width:100%;font-size:14px;justify-content:center;padding:10px}", ""]);
// Exports
module.exports = exports;
